const SectionHeading = ({ number, title, intro }) => {
  return (
    <div className="section-heading">
      <h2><span className="section-number">{number}</span>{title}</h2>
      {intro && <p className="section-intro">{intro}</p>}
    </div>
  );
}

export default SectionHeading;
